import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import styled from "styled-components";
import { fetchHomepage } from "../Redux/slice/homeSlice";
import { Icon } from "@iconify/react";
import { Link, useLocation, useNavigate } from "react-router-dom";

const HomeRap = styled.div`
  .home-1 {
    background-size: cover; /* always cover container */
    background-repeat: no-repeat;
    background-position: top center;

    /* 👇 force it to stick to viewport size */

    width: 100%;

    /* prevent shrinking look */
    background-attachment: fixed;
    padding-top: 180px;
    margin: 10px;
    border-radius: 24px;
    position: relative;
    padding-bottom: 30px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;

    height: 100vh;

    box-sizing: border-box;

    /* background zoom only once */
    animation: bgZoom 8s ease forwards;
  }

  @keyframes bgZoom {
    0% {
      background-size: 100%;
      background-position: center;
    }
    100% {
      background-size: 160%;
      background-position: center;
    }
  }

  .home-1-upper h1 {
    color: #ffffff;
    line-height: 58px;
    font-size: 58px;
    font-weight: 500;

    max-width: 580px;

    opacity: 0;
    transform: translateY(20px);
    animation: fadeSlide 1s ease forwards;
  }

  @keyframes fadeSlide {
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }
  .home-1-line {
    background: #84e717;
    height: 1px;
    width: 157px;
  }
  .home-1-upper-sub {
    display: flex;
    /* gap: 20px; */
  }
  .home-1-upper-down button {
    border: none;
    background: #84e717;
    color: #000000;
    font-size: 15px;
    font-weight: 400;
    width: 175px;
    height: 48px;
    border-radius: 100px;
    cursor: pointer;
  }
  .green-circle {
    background: #84e717;
    cursor: pointer;
    width: 48px;
    height: 48px;
    border-radius: 100px;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .home-1-upper-down:hover button {
    background: #1c4b42;
    color: #b4e717;
  }

  .home-1-upper-down:hover .green-circle {
    background: #1c4b42;
  }

  .home-1-upper-down {
    display: flex;
  }
  .home-1-upper {
    display: flex;
    flex-direction: column;
    gap: 20px;
  }
  .link {
    background: #ffffff33;
    backdrop-filter: blur(40px);
    width: 434px;
    height: 59px;
    border-radius: 20px;
    text-decoration: none;
    display: flex;
    align-items: center;
    padding-left: 15px;
    color: #000000cc;
    font-size: 11px;
    font-weight: 500;
  }
  .link:hover {
    background: #f6f5f2;
  }
  .link.active {
    background: #f6f5f2;
    color: #1c4b42;
  }
  .home-1-down {
    display: flex;
    align-items: center;
    gap: 20px;
    justify-content: space-between;
  }
  .ring-text {
    border: 1px solid #0000001a;
    padding: 5px 10px;
    border-radius: 16px;
    color: #1c4b42;
    font-size: 11px;
    font-weight: 500;
    width: fit-content;
  }
  .home-2-left h2 {
    color: #1c4b42;
    max-width: 660px;
    font-size: 48px;
    font-weight: 400;
    line-height: 57px;
  }
  .home-2-btns button {
    width: 129px;
    height: 47px;
    border-radius: 100px;
    font-size: 15px;
    font-weight: 500;
  }
  .home-2-btn-1 {
    background: #1c4b42;
    color: #ffffff;
    width: 129px;
    height: 47px;
    border-radius: 100px;
    font-size: 15px;
    font-weight: 500;
    display: flex;
    justify-content: center;
    align-items: center;
    text-decoration: none;
  }
  .home-2-btn-1:hover,
  .home-2-btn-2:hover {
    background: #b4e717;
    color: #1c4b42;
  }
  .home-2-btn-2 {
    border: 1px solid #0000001a;
    background: transparent;
    color: #000000cc;
    width: 129px;
    height: 47px;
    border-radius: 100px;
    font-size: 15px;
    font-weight: 500;
    display: flex;
    justify-content: center;
    align-items: center;
    text-decoration: none;
  }
  .home-2-btns {
    display: flex;
    gap: 20px;
  }
  .home-2-left {
    display: flex;
    flex-direction: column;
    gap: 30px;
  }
  .links {
    border-bottom: 1px solid #0000001a;
    width: 36px;
    height: 32px;
    color: #7e7e7e;
    text-decoration: none;
    display: flex;
    align-items: center;
  }
  .links.active {
    border-bottom: 1px solid #92c200;
    color: #1c4b42;
  }
  .home-2-left-upper {
    display: flex;
    gap: 10px;
  }
  .home-2-left p {
    color: #000000cc;
    font-size: 20px;
    line-height: 30px;
    font-weight: 400;
    max-width: 478px;
  }
  .home-2-left {
    display: flex;
    flex-direction: column;
    gap: 20px;
  }
  .home-2 {
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
    margin-top: 80px;
    gap: 30px;
  }

  .home-3-upper-left h6 {
    border: 1px solid #ffffff33;
    border-radius: 16px;
    display: flex;
    justify-content: center;
    align-items: center;
    color: #ffffff;
    font-size: 11px;
    font-weight: 400;
    width: 94px;
    height: 31px;
  }
  .home-3-upper-left h2 {
    font-weight: 400;
    max-width: 700px;
    font-size: 48px;
    line-height: 57px;
    color: #ffffff;
  }
  .home-3-upper-left {
    display: flex;
    flex-direction: column;
    gap: 20px;
  }
  .home-3-upper button {
    background: #f6f5f2;
    font-weight: 500;
    font-size: 15px;
    width: 130px;
    height: 47px;
    border: none;
    cursor: pointer;
    border-radius: 100px;
  }
  .home-3-upper button:hover {
    background: #b4e717;
    color: #1c4b42;
  }
  .home-3-upper {
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
    gap: 20px;
  }
  .home-3 {
    display: flex;
    flex-direction: column;
    gap: 50px;
    margin-top: 80px;
    background: #1c4b42;
    padding-top: 80px;
    padding-bottom: 40px;
  }
  .home-3-circle {
    background: #f6f5f2;
    width: 50px;
    height: 50px;
    white-space: nowrap;
    flex-shrink: 0;
    border-radius: 100px;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .home-3-circle svg {
    color: #1c4b42;
  }
  .home-3-card:hover .home-3-circle {
    background: #1c4b42;
  }
  .home-3-card:hover .home-3-circle svg {
    color: #b4e717;
  }
  .home-3-sub h4 {
    color: #1c4b42;
    font-size: 22px;
    font-weight: 500;
    line-height: 28px;
    max-width: 201px;
  }
  .home-3-sub {
    display: flex;
    padding: 20px;
    justify-content: space-between;
    gap: 20px;
  }
  .home-3-card {
    background: #b4e717;
    width: 305px;
    height: 399px;
    cursor: pointer;
    border-radius: 24px;
    display: flex;
    overflow: hidden;
    position: relative;
    flex-direction: column;

    justify-content: space-between;
  }
  .image-cutting {
    position: absolute;
    top: 0px;
    left: 0px;
    width: 262px;
    height: 262px;
  }

  .image-cut-4 {
    width: 270px;
    height: 270px;
  }
  .up-image-4,
  .up-image-2 {
    border-bottom-right-radius: 100px;
  }
  .home-3-down {
    display: flex;
    gap: 10px;
    justify-content: space-between;
  }
  .home-3-card-img {
    width: 213px;
    object-fit: cover;
    height: 213px;
  }

  .home-3 {
  }
  /* 🔹 Animate home-3-upper (blur in) */
  .home-3-upper {
    opacity: 0;
    filter: blur(10px);
    animation: blurIn 1s ease forwards;
  }

  @keyframes blurIn {
    from {
      opacity: 0;
      filter: blur(10px);
    }
    to {
      opacity: 1;
      filter: blur(0);
    }
  }

  /* 🔹 Animate home-3-down (slide up) */
  .home-3-down {
    opacity: 0;
    transform: translateY(50px);
    animation: slideUp 1s ease forwards;
    animation-delay: 0.5s; /* start after upper */
  }

  @keyframes slideUp {
    from {
      opacity: 0;
      transform: translateY(50px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }
  y .home-4-upper h6 {
    color: #1c4b42;
    font-size: 11px;
    font-weight: 500;
    width: 108px;
    height: 31px;
    border-radius: 16px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .home-4-upper h2 {
    max-width: 732px;
    line-height: 57px;
    font-size: 48px;
    font-weight: 400;

    color: #1c4b42;
    text-align: center;
  }
  .home-4-upper {
    display: flex;
    flex-direction: column;
    gap: 20px;
    align-items: center;
  }
  .home-4-cir {
    width: 45px;
    height: 45px;
    background: #b4e717;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 100px;
  }
  .home-4-card {
    padding: 10px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    border: 1px solid #0000001a;
    width: 290px;
    gap: 50px;
    border-radius: 24px;
    cursor: pointer;
  }
  .home-4-card:hover {
    background: #84e717;
  }
  .home-4-card-sub {
    background: #f6f5f2;
    padding: 20px;
    display: flex;
    gap: 40px;
    border-radius: 16px;
    flex-direction: column;
  }
  .home-4-card-sub h4 {
    color: #1c4b42;
    font-size: 22px;
    font-weight: 500;
  }
  .home-4-card-sub p {
    color: #000000cc;
    font-size: 14px;
    font-weight: 400;
    max-width: 222px;
    line-height: 20px;
  }
  .home-4-down {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 10px;
    justify-content: space-between;
  }
  .home-4 {
    margin-top: 80px;
    display: flex;
    flex-direction: column;
    gap: 40px;
  }
  h2 {
    line-height: 57px;
    font-size: 48px;
    font-weight: 400;

    color: #1c4b42;
  }
  .home-5-card-upper h6,
  .home-6-upper-left h6,
  .home-8-left h6 {
    border: 1px solid #0000001a;
    width: 90px;
    height: 31px;
    font-size: 11px;
    font-weight: 500;
    border-radius: 100px;
    display: flex;
    justify-content: center;
    align-items: center;
    color: #1c4b42;
  }
  .small-green-cirlce {
    width: 42px;
    height: 42px;
  }
  .home-5-card-upper {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .home-5-card-middle h5 {
    color: #1c4b42;
    font-size: 48px;
    font-weight: 400;
  }
  .home-5-card-middle h4 {
    background: #84e717;
    padding: 5px 10px;
    border-radius: 8px;
    color: #1c4b42;
    font-size: 48px;
    font-weight: 400;
    width: fit-content;
  }
  .home-5-card-down {
    color: #000000cc;
    font-size: 16px;
    font-weight: 400;
  }
  .home-5-btn {
    background: #1c4b42;
    font-size: 15px;
    font-weight: 500;
    color: #ffffff;
    text-decoration: none;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 159px;
    height: 47px;
    border-radius: 100px;
  }
  .home-5-btn:hover {
    background: #b4e717;
    color: #1c4b42;
  }
  .home-5-card-down {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 15px;
  }
  .home-5-card-middle {
    display: flex;
    gap: 20px;
    flex-direction: column;
  }
  .home-5-card {
    width: 600px;
    height: 330px;
    backdrop-filter: blur(40px);
    padding: 20px;
    background: #ffffffcc;
    border-radius: 24px;
    display: flex;

    transition: all 0.5s ease-in-out;
    justify-content: space-between;
    flex-direction: column;
  }

  .home-5 {
    background-size: cover;
    height: 100vh;
    margin-top: 80px;
    position: relative;
    padding-top: 40px;
    padding-bottom: 40px;
  }
  .home-6-upper-left h2 {
    max-width: 551px;
  }
  .home-6-upper-left {
    display: flex;
    flex-direction: column;
    gap: 20px;
  }

  .home-6-btn {
    width: 105px;
    height: 47px;
    border-radius: 100px;
    display: flex;
    justify-content: center;
    align-items: center;
    color: #ffffff;
    font-size: 15px;
    background: #1c4b42;
    font-weight: 400;
    text-decoration: none;
  }
  .home-6-btn:hover {
    background: #b4e717;
    color: #1c4b42;
  }
  .home-6-upper {
    display: flex;
    align-items: flex-end;
    justify-content: space-between;
    gap: 20px;
  }
  .home-6-card img {
    width: 160px;
    height: 160px;
    margin: auto;
    border-radius: 200px;
  }
  .card-6-left h4 {
    color: #1c4b42;
    font-size: 18px;
    font-weight: 500;
  }
  .card-6-left p {
    color: #1c4b42;
    font-size: 11px;
    font-weight: 500;
  }
  .card-6-left {
    display: flex;
    flex-direction: column;
    gap: 5px;
  }
  .card-6-right {
    background: #f6f5f2;
    width: 52px;
    height: 52px;
    border-radius: 100px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
  .home-6-card-sub {
    border-top: 1px solid #0000001a;
    padding-top: 15px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 10px;
  }
  .home-6-card {
    background: #ffffff;
    border-radius: 24px;
    width: 305px;
    height: 314px;
    display: flex;
    flex-direction: column;
    padding: 20px;
    cursor: pointer;
    justify-content: space-between;
  }
  .home-6-card:hover {
    background: #b4e717;
  }
  .card-6-right svg {
    color: #1c4b42;
    transition: all 0.3s ease-in-out;
  }

  /* Hover effect */
  .home-6-card:hover .card-6-right {
    background: #1c4b42;
  }

  .home-6-card:hover .card-6-right svg {
    color: #b4e717;
  }
  .home-6-down {
    display: flex;
    gap: 10px;
    margin-top: 50px;
    justify-content: space-between;
  }
  .home-6-7 {
    background: linear-gradient(180deg, #f6f5f2 50%, #ffffff 100%);
    padding-top: 100px;
    padding-bottom: 100px;
  }

  .home-7-left {
    position: relative;
  }
  .home-7-box {
    backdrop-filter: blur(40px);
    background: #ffffffcc;
    border-radius: 20px;
    width: 170px;
    height: 115px;
    display: flex;
    position: absolute;
    right: 20px;
    bottom: 20px;
    justify-content: center;
    align-items: center;
  }
  .home-7-box img {
    width: 100px;
    height: 100px;
    object-fit: cover;
  }
  .card-7-upper h6 {
    border: 1px solid #0000001a;
    width: 143px;
    height: 31px;
    border-radius: 16px;
    display: flex;
    justify-content: center;
    align-items: center;
    color: #1c4b42;
    font-size: 11px;
    font-weight: 500;
  }
  .card-7-upper h3 {
    max-width: 283px;
    line-height: 36px;
    font-size: 30px;
    color: #1c4b42;
    font-weight: 500;
  }
  .card-7-upper {
    display: flex;
    flex-direction: column;
    gap: 20px;
  }
  .card-7-down p {
    color: #000000cc;
    font-size: 16px;
    font-weight: 400;
    max-width: 356px;
    line-height: 22px;
  }
  .card-7-down {
    display: flex;
    flex-direction: column;
    gap: 20px;
  }
  .card-7-btn,
  .-btn {
    border: none;
    background: #1c4b42;
    color: #ffffff;
    width: 175px;
    border-radius: 100px;
    height: 48px;
    font-size: 15px;
    font-weight: 400;
    text-decoration: none;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .card-7-btn:hover {
    background: #ffffff;
    color: #1c4b42;
  }
  .card-7-circle {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 48px;
    height: 48px;
    background: #1c4b42;
    border-radius: 100px;
  }
  .card-7-sub {
    display: flex;
  }
  .home-7-img {
    max-width: 840px;
    height: 588px;
    border-radius: 24px;
  }
  .home-7-card {
    background: #b4e717;
    width: 420px;
    height: 588px;
    border-radius: 24px;
    display: flex;
    padding: 20px;
    flex-direction: column;
    justify-content: space-between;
  }
  .home-7 {
    display: flex;
    gap: 20px;
    margin-top: 80px;
    justify-content: space-between;
  }
  .home-8-left h2 {
    max-width: 546px;
  }
  .home-8-left-sub,
  .home-8-left {
    display: flex;
    flex-direction: column;
    gap: 20px;
  }
  .home-8-left {
    justify-content: space-between;
  }
  .card-8-upper img {
    width: 45px;
    height: 45px;
  }
  .card-8-upper p {
    color: #000000cc;
    font-size: 20px;
    line-height: 30px;
    max-width: 518px;
    font-weight: 400;
    margin-left: 45px;
  }
  .card-8-upper {
    display: flex;
    flex-direction: column;
    gap: 20px;
  }
  .card-8-down-left img {
    width: 54px;
    height: 54px;
    border-radius: 100px;
  }
  .card-8-down-left h4 {
    color: #1c4b42;
    font-size: 15px;
    font-weight: 500;
  }
  .card-8-down-left p {
    color: #7e7e7e;
    font-size: 11px;
    font-weight: 500;
  }
  .card-8-down-left {
    display: flex;
    align-items: center;
    gap: 10px;
  }
  .card-8-down-inner {
    display: flex;
    flex-direction: column;
    gap: 5px;
  }
  .card-8-circle {
    border-radius: 100px;
    width: 52px;
    height: 52px;
    display: flex;
    justify-content: center;
    align-items: center;
    background: #ffffff;
  }

  .card-8-circle svg {
    color: #1c4b42;
    transition: all 0.3s ease-in-out;
  }

  /* Hover effect */
  .card-8-circle:hover {
    background: #1c4b42;
  }

  .card-8-circle:hover svg {
    color: #b4e717;
  }

  .card-8-down-right {
    display: flex;
    gap: 15px;
  }
  .card-8-down {
    display: flex;
    justify-content: space-between;
  }
  .home-8-card {
    background: #f6f5f2;
    width: 640px;
    overflow: hidden;
    height: 400px;
    border-radius: 24px;
    display: flex;
    justify-content: space-between;
    flex-direction: column;
    padding: 20px;
  }

  .-card {
    transition: transform 0.5s ease, opacity 0.5s ease;
  }
  .home-8 {
    display: flex;
    justify-content: space-between;
    gap: 20px;
  }
  .slide-right {
    animation: slideRight 0.5s forwards;
  }
  .slide-left {
    animation: slideLeft 0.5s forwards;
  }

  @keyframes slideRight {
    from {
      transform: translateX(500px);
      opacity: 0;
    }
    to {
      transform: translateX(0);
      opacity: 1;
    }
  }

  @keyframes slideLeft {
    from {
      transform: translateX(-500px);
      opacity: 0;
    }
    to {
      transform: translateX(0);
      opacity: 1;
    }
  }

  .home-9 img {
    width: 87px;
    height: 40px;
  }
  .home-9 {
    padding-top: 50px;
    padding-bottom: 50px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 20px;
    margin-top: 80px;
    flex-wrap: wrap;
    border-top: 1px solid #0000001a;
  }
  .home-10-card img {
    width: 100%;
    height: 290px;
    border-radius: 16px;
  }
  .home-10-card-sub h4 {
    color: #1c4b42;
    font-weight: 500;
    font-size: 11px;
  }
  .home-10-card-sub p {
    color: #1c4b42;
    font-weight: 500;
    font-size: 22px;
    line-height: 28px;
    max-width: 347px;
  }
  .home-10-card-sub,
  .home-10-card-upper {
    display: flex;
    flex-direction: column;
    gap: 15px;
  }
  .home-10-card {
    padding: 20px;
    border-radius: 24px;
    height: fit-content;
    width: 400px;
    display: flex;
    background: #ffffff;
    flex-direction: column;
    gap: 20px;
    justify-content: space-between;
  }
  .home-10-card:hover {
    background: #84e717;
  }
  .card-10-cirle {
    background: #f6f5f2;
  }
  .home-10-card-down {
    display: flex;

    justify-content: flex-end;
    align-items: flex-end;
  }
  .home-10-down {
    display: flex;
    justify-content: space-between;
    gap: 10px;
    margin-top: 50px;
  }
  .home-11-left-upper h6 {
    width: 62px;
    height: 31px;
    font-size: 11px;
    font-weight: 500;
    display: flex;
    color: #1c4b42;
    border-radius: 100px;
    border: 1px solid #0000001a;
    justify-content: center;
    align-items: center;
  }
  .home-11-left-upper p {
    color: #000000cc;
    font-size: 16px;
    font-weight: 400;
    max-width: 430px;
    line-height: 22px;
  }
  .home-11-left-upper h2 {
    max-width: 526px;
  }
  .home-11-left-upper {
    display: flex;
    flex-direction: column;
    gap: 20px;
  }
  .home-11-btn {
    background: #1c4b42;
    color: #ffffff;
    font-size: 15px;
    text-decoration: none;
    width: 129px;
    height: 47px;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 100px;
  }
  .home-11-btn:hover {
    background: #b4e717;
    color: #1c4b42;
  }
  .home-11-left {
    display: flex;
    flex-direction: column;
    gap: 20px;
    justify-content: space-between;
  }
  .home-11-sub h4 {
    color: #1c4b42;
    font-size: 20px;
    font-weight: 500;
  }
  .home-11-sub {
    justify-content: space-between;
    display: flex;
    align-items: center;
  }
  .home-11-right {
    padding-bottom: 20px;
    border-bottom: 1px solid #0000001a;
  }
  .home-11-circle {
    background: #f6f5f2;
    width: 30px;
    height: 30px;
    border-radius: 100px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .home-11-right p {
    color: #1c4b42;
    font-size: 16px;
    font-weight: 400;
    border-top: 1px solid #0000001a;
    padding-top: 20px;
    margin-top: 20px;
    max-width: 630px;
  }
  .home-11-right-all {
    display: flex;
    flex-direction: column;
    gap: 20px;
  }
  .home-11 {
    display: flex;
    justify-content: space-between;
    gap: 20px;
  }
  .home-12-left img {
    width: 42px;
    height: 42px;
  }
  .home-12-sub h3 {
    max-width: 332px;
    line-height: 57px;
    font-size: 48px;
    font-weight: 400;
    color: #ffffff;
  }
  input {
    background: #ffffff;
    width: 361px;
    height: 48px;
    border: none;
    border-radius: 100px;
    padding-left: 15px;
  }
  .home-12-sub button {
    background: #b4e717;
    width: 149px;
    border-radius: 100px;
    height: 47px;
    border: none;
    color: #1c4b42;
    font-size: 15px;
  }
  .home-12-inner {
    display: flex;
    flex-direction: column;
    gap: 15px;
  }
  .home-12-sub button:hover {
    background: #f6f5f2;
    cursor: pointer;
  }
  .home-12-sub {
    display: flex;
    gap: 15px;
    flex-direction: column;
  }
  .home-12-img {
    width: 50%;
    height: 500px;
  }
  .home-12-left {
    padding-top: 50px;
    padding-bottom: 50px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    gap: 50px;
  }
  .home-12 {
    padding-right: 0px;
    background: #1c4b42;
    display: flex;
    justify-content: space-between;
    gap: 20px;
    margin-top: 100px;
  }
  .home-8-btn {
    background: #1c4b42;
    border-radius: 100px;
    width: 200px;
    height: 47px;
    display: flex;
    justify-content: center;
    align-items: center;
    text-decoration: none;
    font-weight: 500;
    font-size: 15px;
    color: #ffffff;
  }
  .home-8-btn:hover {
    background: #84e717;
    color: #1c4b42;
  }

  /* Initial hidden state */
  .animate-left,
  .animate-right {
    opacity: 0;
    transform: translateX(0);
    transition: all 0.8s ease-out;
  }

  /* Left section slides in from left */
  .animate-left {
    transform: translateX(-200px);
  }
  .animate-left.in-view {
    opacity: 1;
    transform: translateX(0);
  }

  /* Right section slides in from right */
  .animate-right {
    transform: translateX(200px);
  }
  .animate-right.in-view {
    opacity: 1;
    transform: translateX(0);
  }
  .animate-slide-up {
    opacity: 0;
    transform: translateY(50px);
    transition: all 0.8s ease-out;
  }

  .animate-slide-up.in-view {
    opacity: 1;
    transform: translateY(0);
  }

  @media (max-width: 1300px) {
    .home-7-img {
      max-width: 700px;
    }
    .home-12 {
      padding-right: 0px !important;
    }
    .home-10-card {
      width: 350px;
    }
  }
  @media (max-width: 1250px) {
    .home-4-card {
      width: 280px;
    }
  }
  @media (max-width: 1200px) {
    .home-3-down {
      flex-wrap: wrap;
    }
    .home-7-img {
      max-width: 650px;
    }
    .home-4-down {
      grid-template-columns: repeat(3, 1fr);
    }
    .home-4-card {
      width: 305px;
    }
  }

  @media (max-width: 1150px) {
    .home-10-down {
      flex-wrap: wrap;
    }
  }
  @media (max-width: 1024px) {
    .home-7 {
      flex-direction: column;
    }
    .home-7-img {
      max-width: 100%;
      height: auto;
    }
  }
  @media (max-width: 992px) {
    .home-2 {
      flex-direction: column;
      align-items: flex-start;
      gap: 50px;
    }
    .home-4-down {
      grid-template-columns: repeat(2, 1fr);
    }
    .home-3-upper,
    .home-6-upper,
    .home-6-down,
    .home-11,
    .home-8 {
      flex-wrap: wrap;
    }
    .home-12 {
      flex-direction: column;
      padding-right: 20px !important;
    }
    .home-12-img {
      width: 100%;
      height: auto !important;
    }
    .home-1-down {
      display: flex;
      gap: 12px;
      overflow-x: auto; /* enable horizontal scrolling */
      -webkit-overflow-scrolling: touch; /* smooth swipe on iOS */
      white-space: nowrap;
      padding: 10px 12px;
      justify-content: flex-start; /* don't space-between on small screens */
      box-sizing: border-box;
      scrollbar-width: none;
    }

    /* each link should not shrink and should sit inline */
    .home-1-down .link {
      flex: 0 0 auto; /* don't grow, don't shrink, width based on content / min-width */
      min-width: 220px; /* choose a mobile-friendly width for each card */
      max-width: 80%;
      width: auto; /* let min-width apply */
      display: inline-flex; /* ensure they behave inline and center contents */
      align-items: center;
      padding-left: 12px;
    }

    /* optional: smaller desktop-sized left/right gaps */
    .home-1-down .link + .link {
      margin-left: 12px;
    }

    /* style scrollbar (optional) */
    .home-1-down::-webkit-scrollbar {
      height: 6px;
      display: none;
    }
    .home-1-down::-webkit-scrollbar-thumb {
      background: rgba(0, 0, 0, 0.15);
      border-radius: 6px;
    }

    /* adjust parent hero for mobile if needed */
    .home-1 {
      /* background-attachment: fixed is problematic on many mobiles — switch to scroll */
      background-attachment: scroll;
      padding-top: 120px; /* smaller top padding on mobile */
      height: auto;
      padding-right: 0px !important;
    }
    .home-1 h1 {
      padding-right: 20px;
    }
    .home-7-img {
      height: auto !important;
    }
    .home-12 {
      padding-left: 0px !important;
      padding-right: 0px !important;
    }
    .home-12-left {
      padding-left: 20px;
    }
  }
  @media (max-width: 700px) {
    .home-5-card {
      width: 100% !important;
      height: auto;
    }
    .home-4-down {
      grid-template-columns: repeat(1, 1fr);
    }
    .home-5-card-down {
      flex-wrap: wrap;
    }
    .home-5 {
      height: 70vh;
    }
    .home-7-card,
    .home-4-card {
      width: 100%;
    }
    .home-8-card {
      height: auto;
    }
    .home-1-upper h1 {
      font-size: 45px;
      line-height: 50px;
    }
    .home-1-down {
      gap: 10px;
      margin-top: 10px;
    }
    .home-7-card {
      height: 390px;
    }
    .home-10-card,
    .home-3-card,
    .home-4-card,
    .home-6-card {
      width: 100%;
    }
    h2 {
      font-size: 28px !important;
      line-height: 32px !important;
    }
  }
  @media (max-width: 500px) {
    /* container that will scroll horizontally */
    .home-7-box {
      width: 150px;
      height: 80px;
    }

    .home-1 {
      padding-top: 80px;
    }
    .home-1 h1 {
      padding-right: 10px;
    }
    .home-3-sub h4,
    .home-4-card-sub h4,
    .card-6-left h4,
    .card-8-down-inner h4,
    .home-11-sub h4 {
      font-size: 19px;
    }
    .home-5-card-middle h4,
    .home-5-card-middle h5 {
      font-size: 28px;
    }
    /* .home-12-img {
      height: 400px;
    } */
    .home-12 {
      padding-left: 0px !important;
      padding-right: 0px !important;
    }
    .home-1 h1 {
      font-size: 35px !important;
      line-height: 40px !important;
    }

    .card-8-down {
      flex-wrap: wrap;
      gap: 20px;
    }
    .card-8-down-right {
      justify-content: space-between;
    }

    .home-10-card img {
      width: 100% !important;
    }
    .home-12-left {
      padding-left: 10px;
    }
    input {
      width: 100%;
    }
  }
`;

const useInViewAnimation = (selector) => {
  useEffect(() => {
    const elements = document.querySelectorAll(selector);

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("in-view");
          }
        });
      },
      { threshold: 0.2 } // 20% visible triggers it
    );

    elements.forEach((el) => observer.observe(el));
    return () => observer.disconnect();
  }, [selector]);
};

const Home = () => {
  const [activeLink, setActiveLink] = useState("");
  const [activeIndex, setActiveIndex] = useState(0);
  const [displayText, setDisplayText] = useState("");
  const [currentIndex, setCurrentIndex] = useState(0);
  const [currentIndexNew, setCurrentIndexNew] = useState(0);
  const [direction, setDirection] = useState("right");
  const [letterIndex, setLetterIndex] = useState(0);
  const [activeIndexNew, setActiveIndexNew] = useState(0); // first open by default

  const [position, setPosition] = useState("top"); // "top" or "bottom"
  const sectionRef = useRef(null);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { homeObject } = useSelector((state) => state.content);

  console.log(homeObject);

  useEffect(() => {
    dispatch(fetchHomepage());
  }, [dispatch]);

  const slider = homeObject?.data?.slider;
  const about = homeObject?.data?.about;
  const serviceHead = homeObject?.data?.service?.headings;
  const service = homeObject?.data?.service?.services;
  const ourValues = homeObject?.data?.ourValues;
  const slidingText = homeObject?.data?.slidingText;
  const teams = homeObject?.data?.teams;
  const trustedPartner = homeObject?.data?.trustedPartner;
  const testimonials = homeObject?.data?.testimonial;
  const partners = homeObject?.data?.partners;
  const insights = homeObject?.data?.insights;
  const faqs = homeObject?.data?.faq;
  const newsletter = homeObject?.data?.newsletter;

  useEffect(() => {
    if (homeObject) {
      setActiveLink(slider[0]?.tab_title);
    }
  }, [homeObject]);

  const activeSlide = activeLink
    ? slider?.find((item) => item?.tab_title === activeLink)
    : null;

  let aboutItems = [];

  try {
    aboutItems = JSON.parse(about?.content);
  } catch (err) {
    console.error("Invalid JSON:", err);
  }

  let slidingTextContent = [];

  try {
    slidingTextContent = JSON.parse(slidingText?.content);
  } catch (err) {
    console.error("Invalid JSON:", err);
  }

  useEffect(() => {
    if (aboutItems.length > 0) {
      setActiveIndex(0);
    }
  }, [about]);

  const location = useLocation();
  useEffect(() => {
    setTimeout(() => {
      window.scrollTo(0, 0);
      document.body.scrollTop = 0;
      document.documentElement.scrollTop = 0;
    }, 0);
  }, [location.pathname]);

  useEffect(() => {
    if (!slidingTextContent.length) return;

    const currentTitle = slidingTextContent[currentIndex].titles;

    if (letterIndex < currentTitle.length) {
      // type one letter at a time
      const timeout = setTimeout(() => {
        setDisplayText((prev) => prev + currentTitle[letterIndex]);
        setLetterIndex((prev) => prev + 1);
      }, 100); // speed (ms) between letters
      return () => clearTimeout(timeout);
    } else {
      // wait before moving to next word
      const timeout = setTimeout(() => {
        setDisplayText("");
        setLetterIndex(0);
        setCurrentIndex((prev) => (prev + 1) % slidingTextContent.length);
      }, 1500); // pause after full word
      return () => clearTimeout(timeout);
    }
  }, [letterIndex, currentIndex, slidingTextContent]);

  useEffect(() => {
    const handleScroll = () => {
      if (!sectionRef.current) return;

      const rect = sectionRef.current.getBoundingClientRect();
      const windowHeight = window.innerHeight;

      // detect how deep user has scrolled inside this section
      const scrollProgress =
        (windowHeight - rect.top) / (rect.height + windowHeight);

      // if user is past ~70% of the section, move to bottom
      if (scrollProgress > 0.7) {
        setPosition("bottom");
      } else {
        setPosition("top");
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const nextSlide = () => {
    setDirection("right");
    setCurrentIndexNew((prev) =>
      prev === testimonials?.lists?.length - 1 ? 0 : prev + 1
    );
  };

  const prevSlide = () => {
    setDirection("left");
    setCurrentIndexNew((prev) =>
      prev === 0 ? testimonials?.lists?.length - 1 : prev - 1
    );
  };

  const activeItem = testimonials?.lists?.[currentIndexNew];

  const toggleFAQ = (index) => {
    setActiveIndexNew((prev) => (prev === index ? null : index));
  };
  const handleLinkClick = (link) => {
    setActiveLink(link);
  };
  const handledetails = (id) => {
    navigate(`/services/details/${id}`);
  };
  useInViewAnimation(".animate-right");
  useInViewAnimation(".animate-left");
  useInViewAnimation(".animate-slide-up");

  return (
    <HomeRap>
      <div
        style={{
          backgroundImage: `linear-gradient(rgba(0,0,0,0.3), rgba(0,0,0,0.3)), url(https://backoffice.holybrookstransportation.com/${activeSlide?.banner})`,
        }}
        className="home-1 containers"
      >
        <div className="home-1-upper">
          <div className="home-1-upper-sub">
            <h1>{activeSlide?.title}</h1>
            {/* <div className="home-1-line"></div> */}
          </div>
          <div className="home-1-upper-down">
            <button>Free Consultation</button>
            <div className="green-circle">
              <Icon
                width="14px"
                height="14px"
                icon="mdi:arrow-top-right"
                style={{ color: " #000000" }}
              />
            </div>
          </div>
        </div>
        <div className="home-1-down">
          {slider?.map((item) => (
            <Link
              className={`link ${
                activeLink === `${item.tab_title}` ? "active" : ""
              }`}
              onClick={() => handleLinkClick(item?.tab_title)}
            >
              {item?.tab_title}
            </Link>
          ))}
        </div>
      </div>
      {about?.status==="show" && (
      <div className="home-2 containers">
        <div className="home-2-left ">
          <h6 className="ring-text">{about?.small_title}</h6>
          <h2>
            {about?.main_title?.split(" ").map((word, index, arr) =>
              index >= arr.length - 3 ? (
                <span key={index} style={{ color: "#b4e717" }}>
                  {word}{" "}
                </span>
              ) : (
                word + " "
              )
            )}
          </h2>
          <div className="home-2-btns">
            <a
              href={about?.first_btn_link}
              className="home-2-btn-1"
              target="_blank"
              rel="noopener noreferrer"
            >
              {about?.first_btn_title}
            </a>

            <a
              href={about?.second_btn_link}
              className="home-2-btn-2"
              target="_blank"
              rel="noopener noreferrer"
            >
              {about?.second_btn_title}
            </a>
          </div>
        </div>

        <div className="home-2-left ">
          <div className="home-2-left-upper">
            {aboutItems?.map((item, index) => (
              <Link
                key={index}
                className={`links ${activeIndex === index ? "active" : ""}`}
                onClick={() => setActiveIndex(index)}
              >
                0{index + 1}
              </Link>
            ))}
          </div>

          {aboutItems?.length > 0 && <p>{aboutItems[activeIndex]?.titles}</p>}
        </div>
      </div>
      ) }
      {serviceHead?.status==="show" ? (
      <div className="home-3 containers">
        <div className="home-3-upper">
          <div className="home-3-upper-left">
            <h6>{serviceHead?.small_title}</h6>
            <h2>
              {serviceHead?.main_title?.split(" ").map((word, index, arr) => {
                const targetIndexes = [arr.length - 3, arr.length - 2]; // 3rd & 2nd to last
                return targetIndexes.includes(index) ? (
                  <span key={index} style={{ color: "#b4e717" }}>
                    {word}{" "}
                  </span>
                ) : (
                  word + " "
                );
              })}
            </h2>
          </div>
          <button>Learn more</button>
        </div>
        <div className="home-3-down animate-slide-up">
          {service?.data?.map((item, index) => {
            const cutImage = `/images/img-${(index % 4) + 1}.png`; // cycles cut-1 → cut-4
            return (
              <div
                onClick={() => handledetails(item?.id)}
                key={index}
                className="home-3-card "
              >
                <img
                  className={`home-3-card-img up-image-${index + 1}`}
                  src={`https://backoffice.holybrookstransportation.com/${item?.banner}`}
                  alt=""
                />
                <div className="home-3-sub">
                  <h4>{item?.main_title}</h4>
                  <div className="home-3-circle">
                    <Icon
                      width="14px"
                      height="14px"
                      icon="mdi:arrow-top-right"
                      s
                    />
                  </div>
                </div>
                <img
                  className={`image-cutting image-cut-${index + 1}`}
                  src={cutImage}
                  alt=""
                />
              </div>
            );
          })}
        </div>
      </div>
      ): ""}
      <div className="home-4 containers">
        <div className="home-4-upper">
          <h6>{ourValues?.headings?.small_title}</h6>
          <h2>
            {ourValues?.headings?.main_title?.split(" ").map((word, index) => {
              const targetIndexes = [2, 3]; // 2nd word (index 1), 3rd word (index 2)
              return targetIndexes.includes(index) ? (
                <span key={index} style={{ color: "#b4e717" }}>
                  {word}{" "}
                </span>
              ) : (
                word + " "
              );
            })}
          </h2>
        </div>
        <div className="home-4-down">
          {ourValues?.values?.map((item) => (
            <div className="home-4-card">
              {/* <div className="home-4-cir"> */}
              <i
                style={{
                  fontSize: "52px",
                  color: "#1c4b42",
                  padding: "30px",
                }}
                class={item?.icon}
              ></i>
              {/* </div> */}
              <div className="home-4-card-sub">
                <h4>{item?.title}</h4>
                <p>{item?.content}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
      {slidingText?.status ==="show" && (
      <div
        style={{
          backgroundImage: `url(https://backoffice.holybrookstransportation.com/${slidingText?.banner})`,
        }}
        className="home-5 containers"
      >
        <div className={`home-5-card`}>
          <div className="home-5-card-upper">
            <h6>{slidingText?.small_title}</h6>
            <img
              className="small-green-cirlce"
              alt=""
              src="/images/icon-3.png"
            />
          </div>
          <div className="home-5-card-middle">
            <h5>{slidingText?.main_title}</h5>
            <h4>{displayText}</h4>
            <div className="home-5-card-down">
              <p>{slidingText?.bottom_text}</p>
              <a
                href={slidingText?.first_btn_link}
                className="home-5-btn"
                target="_blank"
                rel="noopener noreferrer"
              >
                {slidingText?.first_btn_title}
              </a>
            </div>
          </div>
        </div>
      </div>
      )}
      <div className="home-6-7">

        {teams?.heading?.status ==="show" && (
        <div className="home-6 containers">
          <div className="home-6-upper">
            <div className="home-6-upper-left">
              <h6>{teams?.heading?.small_title}</h6>
              <h2>
                {teams?.heading?.main_title?.split(" ").map((word, index) => {
                  const targetIndexes = [1, 2]; // 2nd word (index 1), 3rd word (index 2)
                  return targetIndexes.includes(index) ? (
                    <span key={index} style={{ color: "#b4e717" }}>
                      {word}{" "}
                    </span>
                  ) : (
                    word + " "
                  );
                })}
              </h2>
            </div>
            <a
              target="_blank"
              rel="noopener noreferrer"
              href={teams?.heading?.bottom_link_to}
              className="home-6-btn"
            >
              {teams?.heading?.bottom_title}
            </a>
          </div>
          <div className="home-6-down">
            {teams?.lists?.map((item) => (
              <div className="home-6-card">
                <img
                  src={`https://backoffice.holybrookstransportation.com/${item?.photo}`}
                  alt=""
                />
                <div className="home-6-card-sub">
                  <div className="card-6-left">
                    <h4>
                      {item?.first_name} {item?.last_name}
                    </h4>
                    <p>{item?.title}</p>
                  </div>
                  <div className="card-6-right">
                    <Icon
                      width="14px"
                      height="14px"
                      icon="mdi:arrow-top-right"
                      // style={{ color: " #1c4b42" }}
                    />
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
        )}
        {trustedPartner?.status==="show" && (
        <div className="home-7 containers ">
          <div className="home-7-left">
            <img
              className="home-7-img"
              src={`https://backoffice.holybrookstransportation.com/${trustedPartner?.banner}`}
              alt=""
            />
            <div className="home-7-box">
              <img
                src={`https://backoffice.holybrookstransportation.com/${trustedPartner?.image}`}
                alt=""
              />
            </div>
          </div>
          <div className="home-7-card">
            <div className="card-7-upper">
              <h6>{trustedPartner?.small_title}</h6>
              <h3>{trustedPartner?.main_title}</h3>
            </div>
            <div className="card-7-down">
              <p>{trustedPartner?.content}</p>
              <div className="card-7-sub">
                <a
                  href={trustedPartner?.first_btn_link}
                  className="card-7-btn"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {trustedPartner?.first_btn_title}
                </a>
                <div className="card-7-circle">
                  <Icon
                    width="14px"
                    height="14px"
                    icon="mdi:arrow-top-right"
                    style={{ color: " #b4e717" }}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        )}
      </div>
      {testimonials?.heading?.status==="show" && (
      <div className="home-8 containers">
        <div className="home-8-left ">
          <div className="home-8-left-sub">
            <h6>{testimonials?.heading?.small_title}</h6>
            <h2>
              {testimonials?.heading?.main_title
                ?.split(" ")
                .map((word, index) => {
                  const targetIndexes = [1, 1]; // 2nd word (index 1), 3rd word (index 2)
                  return targetIndexes.includes(index) ? (
                    <span key={index} style={{ color: "#b4e717" }}>
                      {word}{" "}
                    </span>
                  ) : (
                    word + " "
                  );
                })}
            </h2>
          </div>
          <Link to="/testimonials" className="home-8-btn">
            Read All Testimonials
          </Link>
        </div>

        {/* Active Testimonial */}
        <div className={`home-8-card  `}>
          <div className={`card-8-upper slide-${direction}`}>
            <img src="/images/icon-1.png" alt="" />
            <p>{activeItem?.testimony}</p>
          </div>
          <div className="card-8-down">
            <div className="card-8-down-left">
              <img
                src={`https://backoffice.holybrookstransportation.com/${activeItem?.image}`}
                alt=""
              />
              <div className={`card-8-down-inner slide-${direction}`}>
                <h4>{activeItem?.full_name}</h4>
                <p>{activeItem?.title}</p>
              </div>
            </div>
            <div className="card-8-down-right">
              <div className="card-8-circle" onClick={prevSlide}>
                <Icon width="14px" height="14px" icon="mdi:arrow-bottom-left" />
              </div>
              <div className="card-8-circle" onClick={nextSlide}>
                <Icon width="14px" height="14px" icon="mdi:arrow-top-right" />
              </div>
            </div>
          </div>
        </div>
      </div>
      )}
      <div className="containers">
        <div className="home-9 animate-slide-up">
          {partners?.map((item) => (
            <img
              src={`https://backoffice.holybrookstransportation.com/${item?.image}`}
              alt=""
            />
          ))}
        </div>
      </div>
      <div className="home-6-7">
        {insights?.heading?.status==="show" && (
        <div className="home-6 containers">
          <div className="home-6-upper ">
            <div className="home-6-upper-left">
              <h6>{insights?.heading?.small_title}</h6>
              <h2>
                {insights?.heading?.main_title
                  ?.split(" ")
                  .map((word, index) => {
                    const targetIndexes = [1, 1]; // 2nd word (index 1), 3rd word (index 2)
                    return targetIndexes.includes(index) ? (
                      <span key={index} style={{ color: "#b4e717" }}>
                        {word}{" "}
                      </span>
                    ) : (
                      word + " "
                    );
                  })}
              </h2>
            </div>
            <a
              target="_blank"
              rel="noopener noreferrer"
              href={insights?.heading?.bottom_link_to}
              className="home-6-btn"
            >
              {insights?.heading?.bottom_title || "View"}
            </a>
          </div>
          <div className="home-10-down">
            {insights?.lists?.map((item) => (
              <div className="home-10-card ">
                <div className="home-10-card-upper">
                  <img
                    src={`https://backoffice.holybrookstransportation.com/${item?.banner}`}
                    alt=""
                  />
                  <div className="home-10-card-sub">
                    <h4>{item?.category}</h4>
                    <p>{item?.title}</p>
                  </div>
                </div>
                <div className="home-10-card-down">
                  <div className="card-8-circle card-10-cirle">
                    <Icon
                      width="14px"
                      height="14px"
                      icon="mdi:arrow-top-right"
                      style={{ color: "#000000" }}
                    />
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
        )}
      </div>
      {faqs?.heading?.status==="show" && (
      <div className="home-11 containers">
        <div className="home-11-left">
          <div className="home-11-left-upper">
            <h6>{faqs?.heading?.small_title}</h6>
            <h2>{faqs?.heading?.main_title}</h2>
            <p></p>
          </div>
          <a
            href={faqs?.heading?.btn_link}
            className="home-11-btn"
            target="_blank"
            rel="noopener noreferrer"
          >
            {faqs?.heading?.btn_title}
          </a>
        </div>
        <div className="home-11-right-all">
          {faqs?.faqs?.map((item, index) => (
            <div key={index} className="home-11-right">
              <div
                className="home-11-sub"
                onClick={() => toggleFAQ(index)}
                style={{ cursor: "pointer" }}
              >
                <h4>{item.question}</h4>
                <div className={`home-11-circle`}>
                  <Icon
                    width="14px"
                    height="14px"
                    icon={
                      activeIndexNew === index ? "mdi:plus" : "ic:sharp-minus"
                    }
                    style={{ color: "#000000" }}
                  />
                </div>
              </div>
              {activeIndexNew === index && <p>{item.answer}</p>}
            </div>
          ))}
        </div>
      </div>
      )}
      {newsletter?.status === "show" &&(
      <div className="home-12 containers">
        <div className="home-12-left">
          <img src="/images/icon-2.png" alt="" />
          <div className="home-12-sub">
            <h3>Latest News & Resources</h3>
            <div className="home-12-inner">
              <input type="email" placeholder="Email" />
              <button>Subscribe</button>
            </div>
          </div>
        </div>
        <img
          className="home-12-img"
          src={`https://backoffice.holybrookstransportation.com/${newsletter?.banner}`}
          alt=""
        />
      </div>
      )}
    </HomeRap>
  );
};

export default Home;
